<template>
  <vs-chip color="primary" class="p-0 pr-2">
    {{ text }}
    <vx-tooltip :text="toolTipText">
      <vs-button type="flat" color="light" @click="copy" icon-pack="feather" icon="icon-copy" class="w-auto h-auto p-1"></vs-button>
    </vx-tooltip>
  </vs-chip>
</template>

<script>
export default {
  name: 'BadgeClipboard',
  props: {
    text: {
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {
      toolTipText: 'Click to Copy'
    }
  },
  methods: {
    copy () {
      this.$copyText(this.text).then(() => {
        this.toolTipText = 'Copied'
        setTimeout(() => {
          this.toolTipText = 'Click to Copy'
        }, 1000)
      }, () => {
        this.$vs.notify({
          title: 'Failed',
          text: 'Error in copying text',
          color: 'danger',
          iconPack: 'feather',
          position: 'top-center',
          icon: 'icon-alert-circle'
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
